"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const authentication_1 = tslib_1.__importDefault(require("./authentication"));
const registration_1 = tslib_1.__importDefault(require("./registration"));
const browser_1 = tslib_1.__importDefault(require("./browser"));
const transaction_confirmation_1 = tslib_1.__importDefault(require("./transaction_confirmation"));
const base_1 = tslib_1.__importDefault(require("./base"));
const encoding_1 = require("./utils/encoding");
/**
 * Define the base class
 * */
class WebSDK {
    constructor(baseURL, clientID) {
        this._baseURL = baseURL;
        this._clientID = clientID;
    }
}
/**
 * Apply the mixins into the base class via the JS at runtime
 * */
encoding_1.applyMixins(WebSDK, [base_1.default, browser_1.default, authentication_1.default, registration_1.default, transaction_confirmation_1.default]);
exports.default = WebSDK;
//# sourceMappingURL=index.js.map